import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { WebSocketContent, _success, sender } from 'src/app/shared/models/webSocketContent';
import * as CryptoJS from 'crypto-js';
import { SessionService } from 'src/app/shared/services/session.service';
import { RestService } from 'src/app/shared/services/rest.service';
import { MessageService } from 'src/app/shared/message.service';
import { _priodidadeValue, chamadoDados } from 'src/app/shared/models/chamadoDados';
import { Subject, Subscription } from 'rxjs';
import { EntrySelect } from 'src/app/shared/models/EntrySelect.model';
import { environment } from 'src/environments/environment';
import { Utils } from 'src/app/shared/services/utils.service';

@Component({
  selector: 'app-interacao-chamado',
  templateUrl: './interacao-chamado.component.html',
  styleUrls: ['./interacao-chamado.component.css']
})
export class InteracaoChamadoComponent implements OnInit {
  @ViewChildren('messages') messages: QueryList<any>;
  @ViewChild('content') content: ElementRef;
  uuid_chamado: string;//protocolo do chamado
  reload: Subject<any>;
  listaMsg: Array<msg> = [];
  textArea: HTMLTextAreaElement;
  rows: number = 1;
  senderName: string = this.session.getNomeUsuario();
  uuid_user: string = this.session.getUUIDUsuario();
  last: string = null;
  master: boolean = false;
  dados_chamado: chamadoDados = new chamadoDados();
  userName: string;
  listaPrioridades: Array<EntrySelect> = [];
  listaStatus: Array<EntrySelect> = [];
  prevencaoErro: Subscription;
  timer: any;
  SocketStatus: string = 'Conectado';
  listaCoresUsuarios: Array<_colors_users> = [];
  listaAnexosExibicao: Array<any> = [];
  itenMencionado: mencao = new mencao();
  anexoStatus: string = null;
  timerOut: boolean = false;
  showTimeOut: boolean = false;
  carregandoMais: boolean = false;
  todasCarregadas: boolean = false;
  descricaoInput: boolean = false;
  veiculo: string = '';
  listaCategorias: Array<EntrySelect> = [];
  constructor(
    private app: AppComponent,
    private route: ActivatedRoute,
    private session: SessionService,
    private rest: RestService,
    private router: Router,
    private info: MessageService,
    private utils: Utils
  ) {
    this.route.params.subscribe(params => {
      if (params['uuid'] !== undefined) {
        this.uuid_chamado = params['uuid'];
        this.carregarDadosChamado();//carrega os dados do orçamento quando a url é alterada via código
      }
    });
    if (this.router.getCurrentNavigation().extras.state?.dados_chamado != undefined) {
      this.dados_chamado.map(this.router.getCurrentNavigation().extras.state?.dados_chamado);//obtem os dados do orçamentos passados pela navegação da listagem
      if (this.dados_chamado.protocolo_orcamento) {
        let d = this.router.getCurrentNavigation().extras.state?.dados_chamado;
        this.veiculo = d?.marca_descricao + ' - ' + d?.modelo_descricao + ' - ' + d?.versao_descricao + ' - ' + d?.veiculo_descricao;
      }
      else this.veiculo = null;
      if (this.dados_chamado.notificacao.includes(this.uuid_user)) {
        this.dados_chamado.notificacaoAtiva = true;
        $('#flexSwitchCheckDefault').attr('checked', 'checked')
      } else {
        this.dados_chamado.notificacaoAtiva = false;
        $('#flexSwitchCheckDefault').removeAttr('checked');
      }
    }
  }

  ngOnInit(): void {
    this.textArea = document.getElementById('msgSend') as HTMLTextAreaElement;//obtem o textarea do chat para tratamento de css
    this.app.interacaoChamado.subscribe((data: WebSocketContent) => {//increve no subject de mensagem para receber mensagens do chat do chamado
      if (data.uuid_chamado != this.uuid_chamado) return;
      if (data.code == 20 && data.uuid_chamado == this.uuid_chamado && data.type_recipient == 'suport_chamado' && data.sender.uuid != this.uuid_user) {//valida se a mensagem deve ou não ser exibida
        let _msg: msg = new msg();
        _msg.content = this.descriptografarMensagem(String(JSON.parse(data.content).content));//descriptografia do conteudo da mensagem recebida
        _msg.mencao = JSON.parse(data.content)?.mencao;
        _msg.sender_name = data.sender.name;//obtem quem enviou a mensagem
        _msg.side = data.sender.uuid == this.session.getUUIDUsuario() ? 'rigth' : 'left';//define de qual lado a mensagem ira ficar
        if (this.listaCoresUsuarios.findIndex((e: _colors_users) => e.user_name === _msg.sender_name) == -1) {
          let user_color: _colors_users = new _colors_users();
          user_color.user_name = _msg.sender_name;
          this.listaCoresUsuarios.push(user_color);
        }
        this.listaMsg.push(_msg);//adiciona a mensagem na lista de mensagem e exibe ela no box de mensagens
        let i = setInterval(() => {
          this.scrollToBottom();//move o scroll do box de mensagens para o final
          clearInterval(i);
        }, 1);
      } else if (data.code == 24 && data.uuid_chamado == this.uuid_chamado && data.type_recipient == 'suport_chamado' && data.sender.uuid != this.uuid_user) {
        //caso algum anexo sofra modificação ou tenha um novo anexo entra aqui
        this.carreagarAnexos();
      } else if (data.code == 25 && data.uuid_chamado == this.uuid_chamado && data.type_recipient == 'suport_chamado') {
        let _content: any = data.content;
        if (_content.operacao == 'add') {
          this.dados_chamado.notificacao += _content.uuid + ',';
        } else if (_content.operacao == 'remove') {
          this.dados_chamado.notificacao = String(this.dados_chamado.notificacao).replace(_content.uuid, '');
        }
      } else if (data.code == 26 && data.uuid_chamado == this.uuid_chamado && data.type_recipient == 'suport_chamado' && !this.dados_chamado.descricao) {
        //caso o chamado não tenha descrição e uma descrição for adicionada ao chamado (possível apenas pelo usuário que abriu o chamado) a descrição é carregada para os outros usuários
        //que estão dentro do chamado
        this.recarregarPatchChamado();
      } else if ((data.code == 27 || data.code == 28) && data.uuid_chamado == this.uuid_chamado && data.type_recipient == 'suport_chamado') {
        //caso o chamado sofra alteração de status, podendo variar nos status presentes no enviroment
        this.recarregarPatchChamado();
      }
    });

    if (!this.dados_chamado.protocolo) {
      this.carregarDadosChamado();//carrega os dados caso os dados não tenham sido captador na navegação (em caso de reload de página)
    }

    document.getElementById('msgSend').style.height = '0';//definição de altura do box de mensagens

    $("#msgSend").each(function () {//função para manter scroll na parte mais baixa do box de mensagens
      this.setAttribute("style", "height:" + (this.scrollHeight) + "px;overflow-y:hidden;");
    }).on("input", function (e) {
      this.style.height = "0";
      this.style.height = (this.scrollHeight) + "px";
    })
    document.getElementById("msgSend").addEventListener("keydown", function (event) {
      if (event.key == 'Enter' && !event.shiftKey) {//função para envio de mensagens caso o enter seja precionado sem o shift segurado
        $('.btn-send').click();
        event.preventDefault();
      }
    });
    this.master = this.isEmpresaMaster();//define se o usuário é da Arco (usado para exibição de campos)
    this.userName = this.session.retornaLogin();//obtem o login do usuário (usado para definir o nome do "sender" quando enviar mensagem pelo WebSocket)
    if (this.master) {//se o usuário for da Arco os dados de prioridade são carregados para alteração da prioridade do chamado
      environment.prioridadeChamado.forEach((e: any) => {
        this.listaPrioridades.push({ "label": e.label, "value": e.value });
      });
      environment.statusChamado.forEach((e: any) => {
        this.listaStatus.push({ "label": e.label, "value": e.value });
      });
      environment.categoriaChamado.forEach((e: any) => {
        this.listaCategorias.push({ "label": e.label, "value": e.value });
      });
    }

    this.app.monitoramentoConexaoWebSocket.subscribe((msg: WebSocketContent) => {//responsável pelo monitoramento do WebSocket
      if (msg.code == -1) {
        this.SocketStatus = 'Desconectado';
      } else if (msg.code == 0) {
        this.SocketStatus = 'Conectado';
      }
    });
    this.carreagarAnexos();//chama função para carregamento dos anexos
  }

  async carreagarAnexos() {//função asincrona de carregamento de anexos
    this.rest.obterAnexos(this.uuid_chamado).subscribe((data: any) => {//obtem os anexos ja presentes no chamado
      this.listaAnexosExibicao = [];
      if (data.status == 'success') {//retorna success caso exitam anexos e erro caso não tenha anexos anteriores
        data.data.forEach((e: any) => {//passa por todos os anexos existentes
          this.listaAnexosExibicao.push({ "nome": e.nome_arquivo, "usu": e.nome, "canDelete": e.uuid_usuario == this.uuid_user, "uuid": e.uuid });//insere os anexos existentes na listagem
        });
      }
    });
  }

  carregarDadosChamado() {//função que carrega os dados do chamado
    this.rest.obterChamadoProcolo(this.uuid_chamado).subscribe((data: any) => {//obtenção dos dados
      if (data.status == 'success') {
        this.dados_chamado = new chamadoDados();
        this.dados_chamado.map(data.data[0]);//map dos dados recebidos da API para variável
        if (data.data[0].protocolo_orcamento)
          this.veiculo = data.data[0]?.marca_descricao + ' - ' + data.data[0]?.modelo_descricao + ' - ' + data.data[0]?.versao_descricao + ' - ' + data.data[0]?.veiculo_descricao;
        else this.veiculo = null;
        if (this.dados_chamado.notificacao.includes(this.uuid_user)) {
          this.dados_chamado.notificacaoAtiva = true;
          $('#flexSwitchCheckDefault').attr('checked', 'checked')
        } else {
          this.dados_chamado.notificacaoAtiva = false;
          $('#flexSwitchCheckDefault').removeAttr('checked');
        }
        if (this.master) {
          $('#select-prioridade').val(data.data[0].prioridade);//setado a prioridade do chamado (usuários Arco)
          $('#select-status').val(data.data[0].status);//setado a prioridade do chamado (usuários Arco)
          $('#select-categoria').val(data.data[0].categoria);//setado a categoria do chamado (usuários Arco)
        }
      }
      else { this.info.showAlert('O chamado não foi encontrado!'); this.router.navigate(['chamados']); }//caso o chamado não seja encontrado o usuário é redirecionado para a listagem
    });//e mensagem de chamado não encontrado é exibida

    this.rest.obterMensagensChamado(this.uuid_chamado, 0).subscribe((data: any) => {//obtem as mensagens antigas da conversa (obtem as ultimas 10 mensagens)
      this.listaMsg = [];//limpeza da lista
      if (data.status == 'success') {
        let mensagens: Array<any> = data.data;
        mensagens.forEach((e: Array<WebSocketContent>) => {//puxa as mensagens para lista
          let _msg: msg = new msg();
          _msg.content = this.descriptografarMensagem(JSON.parse(e[0].content).content);
          _msg.mencao = JSON.parse(e[0].content)?.mencao;
          _msg.sender_name = e[0].sender.name;
          _msg.side = e[0].sender.uuid == this.uuid_user ? 'rigth' : 'left';
          if (this.listaCoresUsuarios.findIndex((e: _colors_users) => e.user_name === _msg.sender_name) == -1) {
            let user_color: _colors_users = new _colors_users();
            user_color.user_name = _msg.sender_name;
            this.listaCoresUsuarios.push(user_color);
          }
          this.listaMsg.unshift(_msg);
        });
        let i = setInterval(() => {
          this.scrollToBottom();//defini scroll do box de mensagem no final
          clearInterval(i)
        }, 100)
      }
    });

    this.carreagarAnexos();
  }

  recarregarPatchChamado() {
    this.rest.obterChamadoProcoloAsync(this.uuid_chamado).subscribe((data: any) => {//obtenção dos dados
      if (data.status == 'success') {
        this.dados_chamado.descricao = data.data[0]?.descricao;
        this.dados_chamado.status = data.data[0]?.status;
        this.dados_chamado.categoria = data.data[0]?.categoria;
        if (this.master) {
          $('#select-status').val(data.data[0]?.status);
          $('#select-categoria').val(data.data[0]?.categoria);
        }
      }
    });
  }

  retornaCorDoUsuario(user_name: string): string {
    let cor: string = this.listaCoresUsuarios[this.listaCoresUsuarios.findIndex((e: _colors_users) => e.user_name === user_name)].color;
    return cor ? cor : new _colors_users().color;
  }

  isEmpresaMaster(): boolean {
    return this.session.isMaster();
  }

  clickTextoAlerta() {//usado para dar click no text area quando clicado na escrita quando não possuir mensagens anteriores (quando chamado acabou de ser re-aberto)
    $('#msgSend').focus();
  }

  scrollToBottom() {//função que faz com que o scroll do box de mensagens vá para o final
    try {
      this.content.nativeElement.scrollTop = (this.content.nativeElement.scrollHeight + 70);
    } catch (err) { }
  }

  criptografarMensagem(value: string) {//criptografa as mensagens usando o protocolo como chave
    return CryptoJS.AES.encrypt(value, this.uuid_chamado).toString();
  }

  descriptografarMensagem(value: string) {//descriptografa as mensagens usando o protocolo como chave
    try { return CryptoJS.AES.decrypt(value, String(this.uuid_chamado)).toString(CryptoJS.enc.Utf8); } catch { return null; }
  }

  habilitaBotaoEnviar(): boolean {//habilita o botão de enviar quando tiver algo escrito no textarea
    return $('#msgSend').val() ? (this.dados_chamado.status == 'Finalizado' ? false : true) : false;
  }

  titleBotaoEnviar(): string {
    return $('#msgSend').val() ? (this.dados_chamado.status == 'Finalizado' ? 'O Chamado foi finalizado' : 'Enviar Mensagem') : 'Digite uma mensagem antes de enviar';
  }

  retornaDataHora(d: string) {//retorna a data e hora com padrão local (ex: Brasil: dd/MM/yyyy, HH:mm:ss)
    return new Date(d).toLocaleString();
  }

  enviarMensagem() {//função para envio de mensagem no webSocket
    let msgn: any = $('#msgSend').val();
    if (msgn) {//verifica se tem mensagem
      let _msg: msg = new msg();
      _msg.content = msgn;//define conteudo da mensagem que será exibida no box (client atual)
      _msg.mencao = this.itenMencionado.uuid;
      _msg.side = 'rigth';//define o lado que a mensagem será exibida no box (client atual)
      _msg.sender_name = this.senderName;//define o nome do "sender" (client atual)
      let criptoContent = this.criptografarMensagem(_msg.content);//obtem mensagem criptografada para envio no Socket
      let messageSocket: WebSocketContent = new WebSocketContent();
      messageSocket.code = 20;//define o código para envio (vide lista de códigos na declaração da classe)
      let socketContent = {
        "content": criptoContent,
        "mencao": _msg.mencao
      }
      messageSocket.content = JSON.stringify(socketContent);//define mensagem criptografada
      messageSocket.uuid_chamado = this.uuid_chamado;//define protocolo do chamado (eu sei, o nome esta trocado)
      let _sender: sender = new sender();
      _sender.name = this.senderName;//define o nome do "sender"
      _sender.uuid = this.uuid_user//define o uuid do "sender"
      messageSocket.sender = _sender;//define o "sender"
      messageSocket.type_recipient = 'suport_chamado';//define o tipo de envio
      this.app.enviarSocket(messageSocket);//envio da mensagem no WebSocket
      this.listaMsg.push(_msg);//adição da mensagem na lista de mensagens
      $('#msgSend').val(null);//limpeza do textarea
      this.clickTextoAlerta();//click no textarea para digitação de nova mensagem
      this.removerMencao();//remover menção anterior
      document.getElementById('msgSend').style.height = '28px';//caso o temanho do textarea tenha sido alterado essa linha faz voltar ao tamanho original
      let i = setInterval(() => {
        this.scrollToBottom();//defini scroll do box de mensagem no final
        clearInterval(i);
      }, 1);
      this.notificar();//notifica o gestor responsável
    }
  }

  async notificar() {//notifica os atendentes sobre a nova interação do chamado
    let _msg: WebSocketContent = new WebSocketContent();
    _msg.code = 14;//define código da mensagem (vide lista de códigos na declaração da classe)
    _msg.type_recipient = 'notification';//define contexto da mensagem
    _msg.recipient = String(this.dados_chamado.notificacao).replace(this.uuid_user, '');//define quem irá receber a mensagem
    _msg.content = this.dados_chamado.protocolo;//define o content da mensagem, neste caso, o protocolo do chamado
    let _sender: sender = new sender();//definição de "sender"
    _sender.name = this.userName;
    _sender.uuid = this.uuid_user;
    _msg.sender = _sender;
    this.app.enviarSocket(_msg);//envio da notificação
  }

  async alterarPrioridadeChamado() {//função usada para alterar a prioridade do chamado (usuários Arco)
    let pAntiga: _priodidadeValue = this.dados_chamado.prioridade;//obtem prioridade antiga para caso de erro
    let prioridade: number = Number($('#select-prioridade').val());//obtem nova prioridade
    this.dados_chamado.prioridade = prioridade;//define prioridade nos dados do chamado
    let cod = this.utils.uuidv4();//obtem código para monitoramento de erro
    if (this.app.monitorarExecao(cod) == 'remove') {
      this.app.monitorarExecao(cod);
    }
    this.timer = setInterval(() => {//define um timer para validar se a alteração foi bem sucedida
      this.prevencaoErro.unsubscribe();//caso entre aqui, quer dizer que não houve erro ao salvar os dados, ou que o back esta com tempo de resposta muito grande ( > 1 segundo)
      /* Rotina de sucesso */
      clearInterval(this.timer);
    }, 1000);//só será executado após 1 segundo de sua inicialização
    this.prevencaoErro = this.app.monitoramentoErro.subscribe((msg: WebSocketContent) => {//monitora subject de erro do app (OBS: só será disparado caso o back indenfique erro na chamada abaixo)
      if (msg.code == 500) {
        this.info.customAlert({//mensagem de erro em caso de erro
          icon: 'error',
          html: 'Erro ao salvar Prioridade<br>Tente novamente',
          position: 'center',
          timer: 3000,
          timerProgressBar: true
        });
      }
      clearInterval(this.timer);//limpa timer de verificação
      this.prevencaoErro.unsubscribe();//para de monitorar erros
      this.dados_chamado.prioridadeString = pAntiga;//volta a prioridade antiga
      $('#select-prioridade').val(String(this.dados_chamado.prioridadeNumber));
    });
    this.rest.atualizarPrioridadeChamado(this.uuid_chamado, prioridade, cod).subscribe((data: any) => { });//disparo para a API (OBS: nesta chamada)
  }

  async alterarCategoriaChamado() {//função usada para alterar a prioridade do chamado (usuários Arco)
    let cAntiga: string = this.dados_chamado.prioridade;//obtem prioridade antiga para caso de erro
    let categoria: number = Number($('#select-categoria').val());//obtem nova prioridade
    this.dados_chamado.categoria = categoria;//define prioridade nos dados do chamado
    let cod = this.utils.uuidv4();//obtem código para monitoramento de erro
    if (this.app.monitorarExecao(cod) == 'remove') {
      this.app.monitorarExecao(cod);
    }
    this.timer = setInterval(() => {//define um timer para validar se a alteração foi bem sucedida
      this.prevencaoErro.unsubscribe();//caso entre aqui, quer dizer que não houve erro ao salvar os dados, ou que o back esta com tempo de resposta muito grande ( > 1 segundo)
      /* Rotina de sucesso */
      clearInterval(this.timer);
    }, 1000);//só será executado após 1 segundo de sua inicialização
    this.prevencaoErro = this.app.monitoramentoErro.subscribe((msg: WebSocketContent) => {//monitora subject de erro do app (OBS: só será disparado caso o back indenfique erro na chamada abaixo)
      if (msg.code == 500) {
        this.info.customAlert({//mensagem de erro em caso de erro
          icon: 'error',
          html: 'Erro ao salvar Prioridade<br>Tente novamente',
          position: 'center',
          timer: 3000,
          timerProgressBar: true
        });
      }
      clearInterval(this.timer);//limpa timer de verificação
      this.prevencaoErro.unsubscribe();//para de monitorar erros
      this.dados_chamado.categoria = cAntiga;//volta a prioridade antiga
      $('#select-prioridade').val(String(this.dados_chamado.prioridadeNumber));
    });
    this.rest.atualizarCategoriaChamado(this.uuid_chamado, categoria, cod).subscribe((data: any) => { });//disparo para a API (OBS: nesta chamada)
  }

  async alterarStatusChamado() {//função usada para alterar o status do chamado (usuários Arco)
    let sAntiga: string = this.dados_chamado.status;//obtem status antiga para caso de erro
    let status: string = String($('#select-status').val());//obtem nova status
    this.dados_chamado.status = status;//define status nos dados do chamado
    let cod = this.utils.uuidv4();//obtem código para monitoramento de erro
    if (this.app.monitorarExecao(cod) == 'remove') {
      this.app.monitorarExecao(cod);
    }
    this.timer = setInterval(() => {//define um timer para validar se a alteração foi bem sucedida
      this.prevencaoErro.unsubscribe();//caso entre aqui, quer dizer que não houve erro ao salvar os dados, ou que o back esta com tempo de resposta muito grande ( > 1 segundo)
      /* Rotina de sucesso */
      clearInterval(this.timer);
    }, 1000);//só será executado após 1 segundo de sua inicialização
    this.prevencaoErro = this.app.monitoramentoErro.subscribe((msg: WebSocketContent) => {//monitora subject de erro do app (OBS: só será disparado caso o back indenfique erro na chamada abaixo)
      if (msg.code == 500) {
        this.info.customAlert({//mensagem de erro em caso de erro
          icon: 'error',
          html: 'Erro ao salvar Status<br>Tente novamente',
          position: 'center',
          timer: 3000,
          timerProgressBar: true
        });
      }
      clearInterval(this.timer);//limpa timer de verificação
      this.prevencaoErro.unsubscribe();//para de monitorar erros
      this.dados_chamado.status = sAntiga;//volta o status antiga
      $('#select-status').val(String(this.dados_chamado.status));
    });
    this.rest.atualizarStatusChamado(this.uuid_chamado, status, cod).subscribe((data: any) => { });//disparo para a API (OBS: nesta chamada)
  }

  async adicionarDescricaoChamado() {//essa função é responsável pela adição de descrição nos chamados que não possuiem
    //OBS: a descrição do chamado não pode ser editada, esta função permite que uma descrição seja adicionado ao chamado
    //apenas se o chamado em questão não possua uma descrição, além de essa descrição ser possível ser adicionada apenas pelo
    //usuário que abriu o chamado
    this.info.customAlert({//quando o usuário clica em salvar é exibida uma confirmação para o usuário
      //informando que ao adicionar a descrição ela não poderá ser alterada
      icon: 'question',
      title: 'Tem certeza que deseja realizar essa ação?',
      text: 'Ao salvar a descrição você não poderá edita-la!',
      showConfirmButton: true,
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Salvar',
      denyButtonText: 'Ainda Não',
      confirmButtonColor: 'green'
    }).then((data: any) => {
      if (data.isConfirmed) {//caso o usuário confirme a ação
        let descricao: string = String($('#textAreaDescricao').val());//é obtido o valor da descrição
        this.dados_chamado.descricao = descricao;//a nova descrição é setada nos dados do chamado
        let cod = this.utils.uuidv4();//um código para monitoramento de erro é gerado
        if (this.app.monitorarExecao(cod) == 'remove') {
          this.app.monitorarExecao(cod);
        }
        this.timer = setInterval(() => {
          this.prevencaoErro.unsubscribe();
          /* Rotina de sucesso */
          this.descricaoInput = false;
          clearInterval(this.timer);//caso não haja erros e tenha se passado 1 segundo a operação é considerada um sucesso
        }, 1000);
        this.prevencaoErro = this.app.monitoramentoErro.subscribe((msg: WebSocketContent) => {
          //o serviço de monitoramento de erro é observado para em caso de erro ser exibido para o usuário de forma tratada
          if (msg.code == 500) {
            this.info.customAlert({
              icon: 'error',
              html: 'Erro ao salvar Status<br>Tente novamente',
              position: 'center',
              timer: 3000,
              timerProgressBar: true
            });
          }
          clearInterval(this.timer);//caso não tenham erros o timer é destivado
          this.prevencaoErro.unsubscribe();//e a incrição é canceladaa
        });
        this.rest.alterarDescricaoChamado(this.uuid_chamado, descricao, cod).subscribe((data: any) => { });
      }
    });
  }

  habilitarAdicaoDescricao() {
    this.descricaoInput = !this.descricaoInput;
  }


  async salvarArquivos(arquivo: any) {//função de processamento de anexo
    arquivo = arquivo.files;//obtem os dados dos anexos do input
    this.anexoStatus = 'Salvando'
    for (let i = 0; i < arquivo.length; i++) {//para passar por todos os arquivos anexados
      const file = arquivo[i];//obtem os dados do arquivo
      let nome = file.name//obtem o nome do arquivo
      let extensao = String(arquivo[i].name).split('.')[String(arquivo[i].name).split('.').length - 1];//obtem a extensão do arquivo ex: pdf, ppt, jpeg
      // Encode the file using the FileReader API
      const reader = new FileReader();//processamento do arquivo
      reader.onloadend = () => {//função callback para queando o arquivo tenha sido processado completamente
        // Use a regex to remove data url part
        const base64String = String(reader.result)//obtem o arquivo em base64
          .replace('data:', '')
          .replace(/^.+,/, '');

        let jsonArquivo = {//monta o json do arquivo
          "extensao": extensao,//obtem a extensão do arquivo ex:pdf, jpeg, png
          "arquivoBase64": base64String,//obtem o arquivo em base64
          "nomeArquivo": nome//obtem o nome atual do arquivo
        }
        this.enviarArquivo(jsonArquivo);//envia o arquivo para ser salvo

        return (base64String)
        // Logs wL2dvYWwgbW9yZ...
      };
      reader.readAsDataURL(file);
    }
  }

  async enviarArquivo(jsonArquivo: any) {//função de envio do anexo para a API
    if (jsonArquivo) {//verifica se o json recebido não esta vazio
      this.rest.salvarAnexos(jsonArquivo, this.uuid_chamado, this.uuid_user).subscribe((data: any) => {//envia json para salvar
        if (data.status == 'success') {//se retornar sucesso o anexo é adicionado à listagem de anexos
          this.listaAnexosExibicao.push({ "nome": jsonArquivo.nomeArquivo, "uuid": data.uuid, "canDelete": true });
          this.notificarAtualizacaoAnexos();
          this.anexoStatus = 'Salvo';
          let i = setInterval(() => {
            this.anexoStatus = null;
            clearInterval(i);
          }, 1000)
        };
      });
    }
    $('#input-arquivos').val(null);//input de anexos é limpo
  }

  removerMencao() {
    this.itenMencionado = new mencao();//limpa a mensao atual
  }

  marcarArquivo(uuid, nome) {//função responsável pela madição de mensao na mensagem
    if (uuid) {//verifica se o uuid informado não é nulo
      this.itenMencionado = new mencao();//limpa mensao anterior
      this.itenMencionado.uuid = uuid;//define nova mensao
      this.itenMencionado.nome = nome;
      let i = setInterval(() => {
        this.scrollToBottom();
        clearInterval(i);
      }, 100);
      return;
    }
  }

  abrirArquivo(uuid) {//função recebe o uuid do anexo para realizar a abertura
    this.rest.obterURLAnexoEspecifico(this.uuid_chamado, uuid).subscribe((data: any) => {//realiza a consulta para obter url de abertura do anexo
      if (data.status == 'success') {//em caso de sucesso abre o anexo em uma nova aba
        window.open(data.url, '_black');
      }
    });
  }

  retornaNomeArquivoMensao(uuid) {//essa função retorna o nome do arquivo anexado
    let nome = null;
    this.listaAnexosExibicao.forEach((e: any) => {//procura na lista de anexos qual o respectivo nome do uuid informado
      if (e.uuid == uuid) {//caso o uuid seja encontrado
        nome = e.nome;//o nome do arquivo é obtido
        return nome;//nome retornado
      }
    });
    return nome;//nome retornado
  }

  removerAnexo(uuid) {
    this.info.showConfirme('Tem certeza que deseja remover o anexo?').then((data: any) => {//é exibida uma confirmação para que o anexo seja removido
      if (data.isConfirmed) {//caso o usuário confirme a ação
        this.rest.removerAnexosDoChamado(this.uuid_chamado, [uuid]).subscribe((data: any) => {//é enviado para a API o protocolo do chamado (uuid_chamado) e uma lista com os uuids dos anexos desejados
          //neste caso o anexo é excluido um por vez
          if (data.status == 'success') {//em caso de sucesso é gerado um alerta de anexo removido para atualização em tempo real
            this.notificarAtualizacaoAnexos();//alerta de alteração
            for (let i = 0; i < this.listaAnexosExibicao.length; i++) {//o anexo é removido da lista atual de anexos
              if (this.listaAnexosExibicao[i].uuid == uuid) {
                this.listaAnexosExibicao.splice(i, 1);
                return;
              }
            }
          }
        });
      }
    });
  }

  async notificarAtualizacaoAnexos() {//função responsável por alertar alteração de anexos
    let msg = new WebSocketContent();
    msg.code = 24;
    msg.sender.uuid = this.uuid_user;
    msg.uuid_chamado = this.uuid_chamado;
    msg.type_recipient = 'suport_chamado';
    msg.sender.name = this.session.retornaLogin();
    this.app.enviarSocket(msg);
  }

  async alterarNotificacao() {//função responsável por alertar alteração na lista de notificações do chamado
    if (this.timerOut) {//caso a solicitação ja tenha cido feita e esteja em processamento
      this.showTimeOut = true;
      if (this.dados_chamado.notificacaoAtiva) {
        $('#flexSwitchCheckDefault').attr('checked', 'checked')
      } else {
        $('#flexSwitchCheckDefault').removeAttr('checked');
      }
      return;
    }
    this.dados_chamado.notificacaoAtiva = !this.dados_chamado.notificacaoAtiva;//ativação de trava para evitar solicitações repetidas
    let _new: boolean = this.dados_chamado.notificacaoAtiva;//obtenção do novo estado da notificação do chamado (true para ativada e false para desativada)
    if (_new) {//caso seja ativação de notificação
      this.rest.adicionarNotificacaoChamado(this.uuid_chamado).subscribe((data: any) => {//a rota de ativação de notificação é chamada
        if (data.status == 'success') {//em caso de sucesso o uuid do usuário em questão é adicionado na lista de notificação
          this.dados_chamado.notificacao += this.uuid_user + ',';
        } else this.dados_chamado.notificacaoAtiva = !this.dados_chamado.notificacaoAtiva;//em caso de erro o estado é retornado ao antigo
      });
    } else {
      this.rest.removerNotificacaoChamado(this.uuid_chamado).subscribe((data: any) => {//a rota de desativação de notificação é chamada
        if (data.status == 'success') {//em caso de sucesso
          this.dados_chamado.notificacao = String(this.dados_chamado.notificacao).replace(this.uuid_user, '');//o uuid do usuário é removido da lista
        } else this.dados_chamado.notificacaoAtiva = !this.dados_chamado.notificacaoAtiva;
      });
    }
    this.timerOut = true;
    let i = setInterval(() => {
      this.timerOut = false;
      this.showTimeOut = false;
      if (this.dados_chamado.notificacaoAtiva) {
        $('#flexSwitchCheckDefault').attr('checked', 'checked')
      } else {
        $('#flexSwitchCheckDefault').removeAttr('checked');
      }
      clearInterval(i);
    }, 5000)
  }

  async carregarMaisMensagens() {//função para carregamento de mensagens anteriores
    this.carregandoMais = true;//ativa loader
    this.rest.obterMensagensChamado(this.uuid_chamado, this.listaMsg.length).subscribe((data: any) => {//realiza consulta API
      if (data.status == 'success') {//em caso de sucesso
        let mensagens: Array<any> = data.data;
        mensagens.forEach((e: Array<WebSocketContent>) => {//puxa as mensagens para lista
          let _msg: msg = new msg();
          _msg.content = this.descriptografarMensagem(JSON.parse(e[0].content).content);//descriptografa mensagem
          _msg.mencao = JSON.parse(e[0].content)?.mencao;//obtem mencao caso tenha
          _msg.sender_name = e[0].sender.name;//obtem o nome de quem envio
          _msg.side = e[0].sender.uuid == this.uuid_user ? 'rigth' : 'left';//define o lado em que a mensagem ira aparecer
          if (this.listaCoresUsuarios.findIndex((e: _colors_users) => e.user_name === _msg.sender_name) == -1) {//definição da cor do nome do usuário
            let user_color: _colors_users = new _colors_users();
            user_color.user_name = _msg.sender_name;
            this.listaCoresUsuarios.push(user_color);
          }
          this.listaMsg.unshift(_msg);//coloca a mensagem no começo da lista para manter a ordem de envio
        });
      } else if (data.data == 'Não possui mensagens') {
        this.todasCarregadas = true;//caso todas as mensagens ja tenham sido carregadas ou nn tenha mensagens para serem carregadas
      }
      this.carregandoMais = false;//desativa loader
    })
  }

  retornaNomeEmpresaReduzido(nomeCompleto: string) {//função usada para evitar quebras de linha na exibição do nome da empresa
    if (!nomeCompleto) return null;//caso o nomeCompleto tenha entrada nula ou undefined é retornado null
    let listaAux: Array<string> = nomeCompleto.split(" ");//lista auxiliar é gerada separando em cada célula da lista um dos nomes da empresa (separado por estaço)
    let qntCaracteres: number = 20;//aqui é definido qual será a quantidade de caracteres que iram aparecer (para definir deve se subtrair o valor desejado por 3, ex 23 - 3 = 20)
    let r: string = '';
    for (let i = 0; i < listaAux.length; i++) {
      if (qntCaracteres <= 0) {
        return r;
      } else {
        r += listaAux[i].substring(0, qntCaracteres) + ' ';
        qntCaracteres -= listaAux[i].length;
      }
    }
    if (r.length <= nomeCompleto.length) r += '...';
    return r;
  }

  primeiraMensagemNessaSessao() {
    return !(this.listaMsg.length < 10);
  }
}

export class msg {
  content: string;
  sender_name: string;
  side: side;
  mencao: any;
}

export class mencao {
  nome: string;
  uuid: string;
}

export class _colors_users {
  user_name: string;
  private _color: string;
  public get color() {
    return this._color;
  }
  constructor() {
    this._color = this.generatePastelColor();
  }
  private generatePastelColor() {//essa função retorna uma cor pastel no formato hexadecimal para ser usada no nome da pessoa que esta enviando a mensagem
    const r = Math.floor(Math.random() * 156) + 100; // Red component
    const g = Math.floor(Math.random() * 156) + 100; // Green component
    const b = Math.floor(Math.random() * 156) + 100; // Blue component
    const color = `#${r.toString(16)}${g.toString(16)}${b.toString(16)}`;
    return color
  }
}

export type side = 'rigth' | 'left'